
import { renderMessages } from './utils'

const SuccessAlert = ({successData, setSuccessData}) => {
    return (
        <>
            {successData !== null && successData.status !== null ? (
                renderMessages(successData.messages, setSuccessData)
            ) : (
                <div />
            )}
        </>
    );
};


export default SuccessAlert;